<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "阶段添加" : "阶段编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='550'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row v-for="(item, idx) in form.steps" :key="idx">
              <v-col cols="6">
                 <v-select
                  :items="stepItems"
                  label="阶段名称"
                  v-model="form.steps[idx].stepId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <base-marerial-user-select :rules="required" outlined :dense='false' :multiple='false' label='阶段负责人' hide-details v-model="form.steps[idx].operaterId"></base-marerial-user-select>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn class="my-2" depressed fab small :disabled='form.steps.length <= 1' color="primary" @click="form.steps.splice(idx, 1)">
                  <v-icon dark>mdi-minus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn block depressed class="mb-2" @click="addStepPerson()">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
    <v-snackbar v-model="tip.show" rounded="pill" color="warning"><v-icon>mdi-alert-circle-outline</v-icon>&nbsp;<span class="font-weight-bold">{{ tip.text }}</span></v-snackbar>
  </v-container>
</template>

<script>
  import { getByPid } from '@/api/system/dictionary.js'
  import { save } from '@/api/order/step.js'

  export default {
    name: 'OrderStep',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        tip: { show: false, text: '' },
        stepItems: [],
        form: {
          orderId: '',
          steps: [
            {
              id: '',
              stepId: '',
              operaterId: ''
            }
          ]
        },
        defForm: {
          orderId: '',
          steps: [
            {
              id: '',
              stepId: '',
              operaterId: ''
            }
          ]
        }
      }
    },
    methods: {
      save () {
        if (this.form.steps.length > 0) {
          if (this.$refs.form.validate()) {
            this.loading = true
            save(this.form).then(res => {
              if (res.status === 200) {
                this.item.show = false
                this.$emit("on-load-data")
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          }
        } else {
          this.tip = { show: true, text: '至少添加一项进行保存！' }
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.orderId = this.item.orderId
          if (this.isEdit) {
            const this_ = this
            this_.form.steps = []
            this.item.data.steps.forEach(st => {
              this_.form.steps.push(
                {
                  id: st.id,
                  stepId: st.stepId,
                  operaterId: st.operaterId
                }
              )
            });
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
      addStepPerson () {
        this.form.steps.push(
          {
            id: '',
            stepId: '',
            operaterId: ''
          }
        )
      },
      getTypes () {
        getByPid(this.$constants.orderStepPid).then(res => {
          if (res.status === 200) {
            this.stepItems = res.data
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created() {
      this.getTypes()
    },
  }
</script>

<style lang="sass" scoped>
</style>
